
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"cls-1",attrs:{"d":"M2 21.64a.35.35 0 00.35.36H7l-5-5zM15.08 5.33a1 1 0 00-1.41 0L3.31 15.69l5 5 10.37-10.35a1 1 0 000-1.41zM18.33 2A3.6 3.6 0 0016 3l-.34.34 5 5.05L21 8a3.56 3.56 0 001-2.33A3.6 3.6 0 0018.33 2z"}})])
          )
        }
      }
    